export default __webpack_public_path__ + "static/media/Max Miller.69836168.jpg";